import { render, staticRenderFns } from "./Novita.vue?vue&type=template&id=508fdf62&scoped=true"
import script from "./Novita.vue?vue&type=script&lang=js"
export * from "./Novita.vue?vue&type=script&lang=js"
import style0 from "./Novita.vue?vue&type=style&index=0&id=508fdf62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508fdf62",
  null
  
)

export default component.exports